import styled from 'styled-components/macro';

import ShapeIcon from 'components/ShapeSelector/ShapeIcon';

const Rock = styled(ShapeIcon)`
  bottom: 0;
  left: 0;
  margin: 0 auto;
  right: 0;
`;

export default Rock;
